import React from "react";
import {
  manualClaimPermissions,
  placeholderPermissions,
  pricingLevelList,
  testClaimPermissions,
} from "@/App/constants/permissions";

import Dashboard from "@/App/pages/Dashboard";

import TestPatientSearch from "@/App/pages/TestClaim/PatientSearch";
import TestClaimAdjudication from "@/App/pages/TestClaim";
import ManualPatientSearch from "@/App/pages/ManualClaim/PatientSearch";
import ManualClaimAdjudication from "@/App/pages/ManualClaim";
import TestDrugSearch from "@/App/pages/TestClaim/DrugSearch";
import TestClaimPharmacySearch from "@/App/pages/TestClaim/PharmacySearch";
import TestClaimBatchUpload from "@/App/pages/TestClaim/Batch/Upload";
import ManualClaimBatchUpload from "@/App/pages/ManualClaim/Batch/Upload";
import ManualDrugSearch from "@/App/pages/ManualClaim/DrugSearch";
import ManualClaimPharmacySearch from "@/App/pages/ManualClaim/PharmacySearch";
import ViewBatchTestClaims from "@/App/pages/TestClaim/Batch/View";
import ViewBatchManualClaims from "@/App/pages/ManualClaim/Batch/View";

import PricingLevels from "@/App/pages/PricingLevels/pages/List";
import PricingLevelCreate from "@/App/pages/PricingLevels/pages/Create";
import PricingLevelUpdate from "@/App/pages/PricingLevels/pages/Update";

interface RouteProps {
  path: string;
  Component: React.FC<{ pageTitle: string }> | React.ComponentClass;
  pageTitle: string;
  label?: string;
  iconClassName?: string;
  inMainMenu: boolean;
  requiredPermissions: Array<string>;
  breadcrumb?: React.FC | string;
  exact?: boolean;
  isActive?: (match: {}, location: { pathname: string }) => boolean;
  redirectTo?: string;
}

export const appRoutes: Array<RouteProps> = [
  {
    path: "/",
    Component: Dashboard,
    pageTitle: "Dashboard",
    label: "Dashboard",
    iconClassName: "caprx-icon-home",
    inMainMenu: true,
    requiredPermissions: placeholderPermissions, // update
    breadcrumb: "Dashboard",
  },

  {
    path: "/test-claim",
    Component: TestClaimAdjudication,
    pageTitle: "Test Claim",
    label: "Test Claim Adjudication",
    iconClassName: "caprx-icon-money-circle",
    inMainMenu: true,
    requiredPermissions: testClaimPermissions, // update
    breadcrumb: "Test Claim Adjudication",
    exact: false,
  },

  {
    path: "/test-claim/drug",
    Component: TestDrugSearch,
    pageTitle: "Drug Search",
    inMainMenu: false,
    requiredPermissions: placeholderPermissions, // update
    breadcrumb: "Drug Search",
  },

  {
    path: "/test-claim/patient",
    Component: TestPatientSearch,
    pageTitle: "Search for Patient",
    inMainMenu: false,
    requiredPermissions: placeholderPermissions, // update
    breadcrumb: "Search for Patient",
  },

  {
    path: "/test-claim/pharmacy",
    Component: TestClaimPharmacySearch,
    pageTitle: "Search for Pharmacy",
    inMainMenu: false,
    requiredPermissions: placeholderPermissions, // update
    breadcrumb: "Search for Pharmacy",
    exact: false,
  },

  {
    path: "/test-claim/batch/view",
    Component: null,
    pageTitle: "",
    inMainMenu: false,
    requiredPermissions: placeholderPermissions, // update
    breadcrumb: null,
    exact: false,
  },

  {
    path: "/test-claim/batch/view/:id",
    Component: ViewBatchTestClaims,
    pageTitle: "View Test Batch Claims",
    inMainMenu: false,
    requiredPermissions: placeholderPermissions, // update
    breadcrumb: "View",
    exact: false,
  },
  {
    path: "/test-claim/batch",
    Component: TestClaimBatchUpload,
    pageTitle: "Test Claim Batch Upload",
    inMainMenu: false,
    requiredPermissions: placeholderPermissions, // update
  },

  {
    path: "/manual-claim",
    Component: ManualClaimAdjudication,
    pageTitle: "DMR/Manual Claim",
    label: "DMR/Manual Claim Adjudication",
    iconClassName: "caprx-icon-money-circle",
    inMainMenu: true,
    requiredPermissions: manualClaimPermissions, // update
    breadcrumb: "DMR/Manual Claim Adjudication",
    exact: false,
  },

  {
    path: "/manual-claim/drug",
    Component: ManualDrugSearch,
    pageTitle: "Drug Search",
    inMainMenu: false,
    requiredPermissions: placeholderPermissions, // update
    breadcrumb: "Drug Search",
  },

  {
    path: "/manual-claim/patient",
    Component: ManualPatientSearch,
    pageTitle: "Search for Patient",
    inMainMenu: false,
    requiredPermissions: placeholderPermissions, // update
    breadcrumb: "Search for Patient",
  },

  {
    path: "/manual-claim/pharmacy",
    Component: ManualClaimPharmacySearch,
    pageTitle: "Search for Pharmacy",
    inMainMenu: false,
    requiredPermissions: placeholderPermissions, // update
    breadcrumb: "Search for Pharmacy",
    exact: false,
  },

  {
    path: "/manual-claim/batch/view",
    Component: null,
    pageTitle: "",
    inMainMenu: false,
    requiredPermissions: placeholderPermissions, // update
    breadcrumb: null,
  },

  {
    path: "/manual-claim/batch/view/:id",
    Component: ViewBatchManualClaims,
    pageTitle: "View DMR/Manual Batch Claims",
    inMainMenu: false,
    requiredPermissions: placeholderPermissions, // update
    breadcrumb: "View",
    exact: false,
  },
  {
    path: "/manual-claim/batch",
    Component: ManualClaimBatchUpload,
    pageTitle: "DMR/Manual Claim Batch Upload",
    inMainMenu: false,
    requiredPermissions: placeholderPermissions, // update
  },

  {
    path: "/pricing-levels",
    Component: PricingLevels,
    label: "Pricing",
    pageTitle: "Pricing",
    inMainMenu: false,
    requiredPermissions: pricingLevelList,
    breadcrumb: "Pricing",
    exact: false,
  },
  {
    path: "/pricing-levels/create",
    Component: PricingLevelCreate,
    label: "Pricing Level - Create",
    pageTitle: "Pricing Level - Create",
    inMainMenu: false,
    requiredPermissions: pricingLevelList,
    breadcrumb: "Create",
    exact: false,
  },
  {
    path: "/pricing-levels/:id",
    Component: null,
    pageTitle: "",
    inMainMenu: false,
    requiredPermissions: pricingLevelList,
    breadcrumb: null,
  },
  {
    path: "/pricing-levels/:id/edit",
    Component: PricingLevelUpdate,
    label: "Pricing Level - Update",
    pageTitle: "Pricing Level - Update",
    inMainMenu: false,
    requiredPermissions: pricingLevelList,
    breadcrumb: "Update",
    exact: false,
  },
];
